import { render } from "./ListMyAssets.vue?vue&type=template&id=7115c150&scoped=true"
import script from "./ListMyAssets.vue?vue&type=script&lang=js"
export * from "./ListMyAssets.vue?vue&type=script&lang=js"

import "./ListMyAssets.vue?vue&type=style&index=0&id=7115c150&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7115c150"]])

export default __exports__